import { Component, Input } from '@angular/core';

@Component({
  selector: 'result-list-stats',
  templateUrl: 'result-list-stats.html'
})
export class ResultListStatsComponent {

  @Input() itemSingular: string;
  @Input() itemNone: string;
  @Input() itemPlural: string;

  @Input()
  list: Array<any>;

  constructor() {
    this.list = [];
    this.itemNone = "Kein Eintrag";
    this.itemSingular = "Ein Eintrag";
    this.itemPlural = "Einträge";
  }

}



// WEBPACK FOOTER //
// ./src/components/result-list-stats/result-list-stats.ts